import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import * as _ from "lodash";
import { ToastService } from "ng-uikit-pro-standard";
import { ClienteProveedorService } from "src/app/services/cliente-proveedor.service";
import { FamiliaService } from "src/app/services/familia.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { RubroService } from "src/app/services/rubro.service";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { ConsoleService } from "src/app/shared/services/console.service";
import { DatesService } from "src/app/shared/services/dates.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { RutService } from "src/app/shared/services/rut.service";
import { SecurityService } from "src/app/shared/services/security.service";
import { ModalSeleccionarClienteTiposComponent } from "src/app/views/shared/modal-seleccionar-cliente-tipos/modal-seleccionar-cliente-tipos.component";
import { ModalSeleccionarClienteComponent } from "src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component";

@Component({
  selector: "app-detalle-productos",
  templateUrl: "./detalle-productos.component.html",
  styleUrls: ["./detalle-productos.component.scss"],
  providers: [SecurityService]
})
export class DetalleProductosComponent implements OnInit {
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalSeleccionarClienteTiposComponent, { static: true }) modalSeleccionarClientesTipos: ModalSeleccionarClienteTiposComponent

  // Constants
  readonly TIPO_CLIENTE: String = "_TIPO_CLIENTE_"
  readonly TIPO_TIPO_CLIENTE: String = "_TIPO_TIPO_CLIENTE_"

  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  private currentPayload: any = null
  loading: boolean = false
  listaMovimientos: Array<any> = null
  listaMovimientosAll: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  resumen_totales: any = null
  optionsRubro: Array<any> = [];
  optionsFamilia: Array<any> = [];

  clientesSeleccionados: Array<any> = null
  tiposClientesSeleccionados: any = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private rubroService: RubroService,
    private familiaService: FamiliaService,
    private clienteProveedorService: ClienteProveedorService,
    private rutService: RutService
  ) {
    this.log = this.clog.log('REP. PRODUCTOS ANUALIZADO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10
    this.loadRubros()

    this.createForm()
    this.formChangesSubscriptions()
  }

  private loadRubros() {
    this.rubroService.obtenerRubrosReporteVenta(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map(rubro => ({ value: rubro.codigo, label: rubro.descripcion, ...rubro }))
    })
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      buscarPor: [this.TIPO_CLIENTE],
      producto_descuento: [false, []],
      listaRubro: [[]],
      listaFamilia: [[]],
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("buscarPor").valueChanges.subscribe(buscarPor => {
      this.log('change ', buscarPor)
      this.modalSeleccionarCliente.clearClientesSeleccionadosFromOutside()
    })
    this.formHeader.get("listaRubro").valueChanges.subscribe((rubro: string) => {
      this.onRubroSelect(rubro)
    })
  }

  onRubroSelect(ev) {
    this.optionsFamilia = []

    const listaRubros = this.formHeader.get('listaRubro').value
    if (!listaRubros) return

    for (let i = 0; i < listaRubros.length; i++) {
      this.loadFamilias(listaRubros[i])
    }
  }

  private loadFamilias(codigoRubro: Number) {
    this.familiaService.obtenerFamiliaxRubroReporteVenta(this.rutEmpresa, codigoRubro, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      let options = registros.map(p => ({ value: p.codigo, label: p.nombre }))
      this.optionsFamilia = this.optionsFamilia.concat(options)
    })
  }

  /********* MODALS *********/
  limpiarBuscarPorCliente() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
  }

  limpiarBuscarPorTiposClientes() {
    this.tiposClientesSeleccionados = null
    this.modalSeleccionarCliente.cleanLast()
  }

  limpiarDataSeleccionada() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
    this.tiposClientesSeleccionados = null
  }

  abrirModalSeleccion() {
    if (this.formHeader.get('buscarPor').value === this.TIPO_CLIENTE)
      this.abrirModalSeleccionarCliente()
    else if (this.formHeader.get('buscarPor').value === this.TIPO_TIPO_CLIENTE)
      this.abrirModalSeleccionarClientesTipos()
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show()
  }

  abrirModalSeleccionarClientesTipos() {
    this.modalSeleccionarClientesTipos.show(!this.tiposClientesSeleccionados)
  }

  abrirModalSeleccionarClienteSeleccionados() {
    this.modalSeleccionarCliente.showSelected()
  }

  abrirModalSeleccionarTiposClienteSeleccionados() {
    this.modalSeleccionarClientesTipos.showSelected()
  }

  onClienteSeleccionadoMultiple({ data, origen }) {
    this.log(origen, data)
    this.limpiarDataSeleccionada()
    // this.clienteSeleccionado = data
    this.clientesSeleccionados = data
  }

  onClienteSeleccionado({ data, origen }) {
    this.limpiarDataSeleccionada()
    // this.formHeader.get('rutCliente').setValue('')
    this.clientesSeleccionados = [data]
  }

  onClienteTiposSeleccionado({ data, origen }) {
    this.log(origen, data)
    this.limpiarDataSeleccionada()
    this.tiposClientesSeleccionados = data
  }
  /********* MODALS *********/

  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.paginationContext.CurrentPage = pageNumber

    this.listaMovimientos = null
    this.listaMovimientosAll = null

    const { fechaDesde, fechaHasta, buscarPor, producto_descuento, listaRubro, listaFamilia } = this.formHeader.value
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaTipoCliente: [],
        listaCliente: [],
        listaRubro: listaRubro === null ? [] : listaRubro,
        listaFamilia: listaFamilia === null ? [] : listaFamilia,
        producto_descuento
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1
    }
    if (buscarPor === this.TIPO_CLIENTE) {
      inputParams.entidad.listaCliente = (this.clientesSeleccionados && this.clientesSeleccionados.length > 0) ?
        this.clientesSeleccionados.map(tipo => tipo.rut)
        : []
    }
    if (buscarPor === this.TIPO_TIPO_CLIENTE) {
      inputParams.entidad.listaTipoCliente = (this.tiposClientesSeleccionados && this.tiposClientesSeleccionados.length > 0) ?
        this.tiposClientesSeleccionados.map(tipo => tipo.codigo)
        : []
    }

    this.currentPayload = inputParams
    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.clienteProveedorService.obtenerReporteVentaClienteDetalleProducto(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta
      this.listaMovimientosAll = registros
      this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = 1

      this.listaMovimientosAll.forEach(mov => {
        mov.rutFormato = this.rutService.AgregarDV(mov.rut)
      })

      this.showPage(this.paginationContext.CurrentPage)
      this.calculateTotales()
      this.loading = false
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  calculateTotales() {
    this.resumen_totales = {
      monto_neto: _.sumBy(this.listaMovimientosAll, 'monto_neto'),
      descuento: _.sumBy(this.listaMovimientosAll, 'descuento'),
      neto_total: _.sumBy(this.listaMovimientosAll, 'neto_total')
    }
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.clienteProveedorService.obtenerReporteVentaClienteDetalleProductoExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }
  LimpiarData(){
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.clientesSeleccionados = null;
    this.tiposClientesSeleccionados = [null]
    this.formHeader.reset();
    this.formHeader.get('fechaDesde').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
    this.formHeader.get("buscarPor").setValue(this.TIPO_CLIENTE)
    this.formHeader.get("listaRubro").setValue([])
    this.formHeader.get("listaFamilia").setValue([])
    this.formHeader.get("producto_descuento").setValue(false)
    this.listaMovimientos = null
    this.listaMovimientosAll = null
  }
}
